package ru.villawonka.app.presentation.screens.settings.compose.view

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.MaterialTheme
import androidx.compose.material.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.unit.dp
import ru.villawonka.app.presentation.design.extensions.AppSeparator
import ru.villawonka.app.presentation.design.extensions.AppSpacer
import ru.villawonka.app.presentation.design.theme.AppTextStyles
import ru.villawonka.app.presentation.design.theme.filledButtonSecondaryContentInverted

enum class SettingsItemPosition {
    FIRST,
    REGULAR,
    LAST,
    SINGLE,
}

@Composable
fun ColumnScope.SettingsItemView(
    icon: (@Composable () -> Unit)? = null,
    key: String,
    value: String? = null,
    position: SettingsItemPosition = SettingsItemPosition.REGULAR,
    onClick: () -> Unit
) {
    val cornerRadius = 16.dp
    val clickableShape = when (position) {
        SettingsItemPosition.FIRST -> RoundedCornerShape(
            topStart = cornerRadius,
            topEnd = cornerRadius
        )
        SettingsItemPosition.LAST -> RoundedCornerShape(
            bottomStart = cornerRadius,
            bottomEnd = cornerRadius
        )
        SettingsItemPosition.SINGLE -> RoundedCornerShape(cornerRadius)
        SettingsItemPosition.REGULAR -> RoundedCornerShape(0)
    }

    Row(
        verticalAlignment = Alignment.CenterVertically,
        modifier = Modifier
            .clip(clickableShape)
            .clickable { onClick() }
    ) {
        icon?.let {
            AppSpacer(16.dp)
            icon()
        }
        AppSpacer(16.dp)
        Column {
            Row(
                horizontalArrangement = Arrangement.SpaceBetween,
                verticalAlignment = Alignment.CenterVertically,
                modifier = Modifier
                    .height(64.dp)
                    .fillMaxWidth()
            ) {
                Text(
                    text = key,
                    style = AppTextStyles.bodyMediumBold,
                    color = MaterialTheme.colors.onSurface
                )
                value?.let {
                    Text(
                        text = it,
                        style = AppTextStyles.bodyMediumRegular,
                        color = MaterialTheme.colors.filledButtonSecondaryContentInverted,
                        modifier = Modifier.padding(end = 16.dp)
                    )
                }
            }

            if (position != SettingsItemPosition.SINGLE && position != SettingsItemPosition.LAST) {
                AppSeparator()
            }
        }
    }
}